import request from './request';

const GET_PACKAGE_CLAIM_RECORDS = 'amp2.MrmsSrv/GetGiftRecord';
const GET_PACKAGE_CLAIM_RECORDS_FLOW_3 = 'action/api/common/queryDeliverResource';
const FLOW_VERSION_3 = 2;
export default class ClaimRecord {
    static async getClaimRecords(params) {
        console.log("getClaimRecords",params)
        if (params?.flow_version && params.flow_version === FLOW_VERSION_3) {
            return request.post(GET_PACKAGE_CLAIM_RECORDS_FLOW_3, params);
        }
        return request.post(GET_PACKAGE_CLAIM_RECORDS, params);
    }
}
